import { useMutation } from '@tanstack/react-query';

import { organizationServices } from '../../index';

export const useUserSignUp = () => useMutation(params => organizationServices.signUpUser(params));
